// Map class numbers to their corresponding descriptions
export const CLASS_NUMBER_TO_DESCRIPTION: Record<number, string> = {
  15: 'Beef',
  30: 'Pork',
  31: 'Poultry',
  33: 'Seafood',
  32: 'Processed Meat',
  34: 'Specialty Meats',
  21: 'Dairy',
  18: 'Cheese',
  25: 'Produce, Fresh',
  17: 'Fruits & Vegetables, Canned & Dried',
  22: 'Grocery, Dry',
  26: 'Grocery, Ref & Fzn',
  29: 'Oils & Shortening',
  20: 'Appetizers, Entrees, & Potatoes Ref & Fzn',
  35: 'Salads, Wet, Ref & Fzn',
  37: 'Meat Substitute',
  16: 'Beverage',
  19: 'Chemicals & Cleaning Agents',
  24: 'Disposables',
  23: 'Equipment & Supplies',
};
